function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 7410,
  height: 3900,
  fill: "#b22234"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0",
  stroke: "#fff",
  strokeWidth: 300
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 2964,
  height: 2100,
  fill: "#3c3b6e"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  id: "s18"
}, /*#__PURE__*/React.createElement("g", {
  id: "s9"
}, /*#__PURE__*/React.createElement("g", {
  id: "s5"
}, /*#__PURE__*/React.createElement("g", {
  id: "s4"
}, /*#__PURE__*/React.createElement("path", {
  id: "s",
  d: "M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s",
  y: 420
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s",
  y: 840
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s",
  y: 1260
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s",
  y: 1680
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s4",
  x: 247,
  y: 210
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s9",
  x: 494
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s18",
  x: 988
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s9",
  x: 1976
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s5",
  x: 2470
}));
function SvgEuaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1235,
    height: 650,
    viewBox: "0 0 7410 3900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuaFlag);
export default __webpack_public_path__ + "static/media/eua_flag.33c8035805d0139924dd472c4d5b3adf.svg";
export { ForwardRef as ReactComponent };